import React from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import smoothscroll from "smoothscroll-polyfill";
import App from "./App";
import { AuthProvider } from "./hooks/authProvider/authProvider";
import "./index.css";
import "./lib/amplify-configure";
import reportWebVitals from "./reportWebVitals";

smoothscroll.polyfill();

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <App />
        <ToastContainer autoClose={2000} />
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
